export const SOCKET_CONNECTION = "SOCKET_CONNECTION";
export const TWILIO_CONNECTION = "TWILIO_CONNECTION";
